import { useEffect } from "react";
import ReactGA from "react-ga4";
import { LuArrowLeft, LuPanelRightClose } from "react-icons/lu";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import {
  useProjectFilesListActions,
  useProjectFilesSelectedFilePath,
} from "../../core_stores/useProjectFilesListStore";
import { useProjectId } from "../../core_stores/useProjectStore";
import {
  useDashboardControlsActions,
  WorkspaceSection,
} from "../../view_stores/useDashboardControlsStore";
import { SplitPanel } from "../common_components/SplitPanel";
import { ProjectFilesSelectedFile } from "./components/ProjectFilesSelectedFile";
import { ProjectFilesTree } from "./components/ProjectFilesTree";

export function ProjectFiles() {
  const isCompactView = useIsCompactView();
  const projectId = useProjectId();
  const { loadForProject, onFileSelected } = useProjectFilesListActions();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", title: "Workspace Code" });
  }, []);

  useEffect(() => {
    if (projectId) {
      loadForProject(projectId);
    }

    return () => {
      onFileSelected(null);
    };
  }, [projectId]);

  return isCompactView ? <CompactView /> : <DefaultView />;
}

function CompactView() {
  const selectedFilePath = useProjectFilesSelectedFilePath();
  const { onFileSelected } = useProjectFilesListActions();

  return (
    <div className="w-full h-full flex flex-col">
      <ProjectFilesTree />
      <div
        className={`absolute top-0 right-0 h-full w-full 
          flex flex-col
          transition-transform duration-300 ease-in-out ${
            selectedFilePath ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div
          className="h-12 flex items-center justify-start p-2 gap-2
        text-light-text dark:text-dark-text
        bg-light-surface-primary dark:bg-dark-surface-tertiary"
        >
          <LuPanelRightClose
            size={24}
            onClick={() => onFileSelected(null)}
            className="cursor-pointer"
          />
          <div className="flex-1 overflow-x-auto whitespace-nowrap">
            {selectedFilePath}
          </div>
        </div>
        <div className="bg-light-surface-primary dark:bg-dark-surface-tertiary h-full">
          <ProjectFilesSelectedFile />
        </div>
      </div>
    </div>
  );
}

function DefaultView() {
  const { setWorkspaceSection } = useDashboardControlsActions();

  return (
    <SplitPanel
      leftChild={
        <div className="flex flex-col h-full w-full">
          <button
            onClick={() => setWorkspaceSection(WorkspaceSection.SETTINGS)}
            className="flex items-center gap-2 p-2 m-2 
          text-light-text dark:text-dark-text
          hover:bg-light-hover dark:hover:bg-black 
          transition-colors rounded-md"
          >
            <LuArrowLeft size={20} />
            <span>Back</span>
          </button>
          <ProjectFilesTree />
        </div>
      }
      rightChild={<ProjectFilesSelectedFile />}
    />
  );
}
